import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import styles from "./Search.css";
import SearchInputAndSuggestions from "./Components/SearchInputAndSuggestions";
import Header from "../Header/Header";

class Search extends Component {
  render() {
    const { searchOpen, searchUrl, langCode, opening_hours } = this.props;

    const {
      currentRoute,
      onMenuToggle,
      onSearchToggle,
      menuOpen,
      activeMenuIndex,
      setActiveMenuIndex,
    } = this.props;

    return (
      <nav className={searchOpen ? styles.searchOpen : styles.Search}>
        {/* <Framer state={FrameStates.MENU} /> */}

        <div className={styles.centered}>
          <Header
            currentRoute={currentRoute}
            onMenuToggle={onMenuToggle}
            onSearchToggle={onSearchToggle}
            menuOpen={menuOpen}
            searchOpen={searchOpen}
            activeMenuIndex={activeMenuIndex}
            setActiveMenuIndex={setActiveMenuIndex}
          />
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-0 col-md-6"></div>
              <div className="col-xs-11 col-md-5">
                <p
                  dangerouslySetInnerHTML={{ __html: opening_hours.message }}
                />
                <SearchInputAndSuggestions
                  searchOpen={searchOpen}
                  searchUrl={searchUrl}
                  langCode={langCode}
                />
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/components/Search/Search.js